module.exports = __webpack_public_path__ + "img/o.807c6b49.jpg";